export default {"src":"/_next/static/media/nft-sold.754de501.svg","height":24,"width":24};